"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COGNITO_IDP_SERVICE_NAME = void 0;
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */
exports.COGNITO_IDP_SERVICE_NAME = 'cognito-idp';
